import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { PageBusinessCustomer } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'PageContent',
    events: {
        'Load Page Business Customer': emptyProps(),
        'Load Page Business Customer Success': props<{ content: PageBusinessCustomer }>(),
        'Load Page Business Customer Failure': props<{ error: string }>(),
    },
});
